import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files directly for preloading
import enCommon from './locales/en/common.json';
import enNavbar from './locales/en/navbar.json';
import enFooter from './locales/en/footer.json';
import enHome from './locales/en/home.json';
import enAbout from './locales/en/about.json';
import enAssessment from './locales/en/assessment.json';
import enContact from './locales/en/contact.json';
import enVetting from './locales/en/vetting.json';
import enGeneral from './locales/en/general.json';

import swCommon from './locales/sw/common.json';
import swNavbar from './locales/sw/navbar.json';
import swFooter from './locales/sw/footer.json';
import swHome from './locales/sw/home.json';
import swAbout from './locales/sw/about.json';
import swAssessment from './locales/sw/assessment.json';
import swContact from './locales/sw/contact.json';
import swVetting from './locales/sw/vetting.json';
import swGeneral from './locales/sw/general.json';

// Create a resource object with all translations
const resources = {
  en: {
    common: enCommon,
    navbar: enNavbar,
    footer: enFooter,
    home: enHome,
    about: enAbout,
    assessment: enAssessment,
    contact: enContact,
    vetting: enVetting,
    general: enGeneral
  },
  sw: {
    common: swCommon,
    navbar: swNavbar,
    footer: swFooter,
    home: swHome,
    about: swAbout,
    assessment: swAssessment,
    contact: swContact,
    vetting: swVetting,
    general: swGeneral
  }
};

console.log("i18n initialized with resources:", resources);

i18n
  // Use language detector
  .use(LanguageDetector)
  // Use react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    // Default namespace
    defaultNS: 'common',
    
    // Configure language detector options
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
    
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    
    // Load namespaces on demand
    ns: ['common', 'home', 'navbar', 'footer', 'about', 'assessment', 'contact', 'vetting', 'general'],

    react: {
      useSuspense: true,
    },
  });

// For debugging
i18n.on('languageChanged', (lng) => {
  console.log(`Language changed to: ${lng}`);
});

export default i18n; 